import React from 'react';
import { cn } from './Button';
import { useTheme } from '../../hooks/useTheme';
export function Card({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  const {
    theme
  } = useTheme();
  const isLight = theme === 'light';
  return <div className={cn('rounded-lg border', className)} style={{
    borderColor: isLight ? 'rgba(255, 255, 255, 0.80)' : 'var(--border-strong)',
    backgroundColor: isLight ? 'rgba(255, 255, 255, 0.65)' : 'var(--bg-surface)',
    backdropFilter: isLight ? 'blur(20px) saturate(180%)' : undefined,
    WebkitBackdropFilter: isLight ? 'blur(20px) saturate(180%)' : undefined,
    boxShadow: isLight ? '0 2px 8px rgba(148, 163, 184, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.95) inset, 0 1px 0 rgba(255, 255, 255, 0.90) inset' : '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    color: 'var(--text-primary)'
  }} {...props} data-id="element-1122" />;
}